import styled from 'astroturf/react'
import _Header from "styles-Header.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/meeting_poll_confirmation/styles.js?styleId=Header";
import _DetailsWrapper from "styles-DetailsWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/meeting_poll_confirmation/styles.js?styleId=DetailsWrapper";
import _Title from "styles-Title.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/meeting_poll_confirmation/styles.js?styleId=Title";
import _Description from "styles-Description.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/meeting_poll_confirmation/styles.js?styleId=Description";

const colorTextSecondary = 'var(--colorTextSecondary, var(--coreColorNeutral600))'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
const spaceXLarge = 'var(--spacing-1-5x, 1.5rem)'
const spaceLarge = 'var(--spacing-1x, 1rem)'

const Header = /*#__PURE__*/styled('div', null, {
  displayName: "Header",
  styles: _Header
})

export const DetailsWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "DetailsWrapper",
  styles: _DetailsWrapper
})

const Title = /*#__PURE__*/styled('h1', null, {
  displayName: "Title",
  styles: _Title
})

const Description = /*#__PURE__*/styled('p', null, {
  displayName: "Description",
  styles: _Description
})

export {
  Header,
  Title,
  Description
}
